import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IForgotPasswordData, IForgotPasswordGenerateCodeResponse } from '../../types/forgotPassword.types';
import { RootState } from '../index';
import { forgotPasswordApi } from './forgotPassword.api';

const initialForgotPasswordState: IForgotPasswordData = {
  username: '',
  transactionId: '',
  email: '',
  phone: '',
};

const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState: initialForgotPasswordState,
  reducers: {
    setUsername(state, { payload }: PayloadAction<string>) {
      state.username = payload;
    },
    abortPasswordReset(state) {
      state.transactionId = '';
      state.email = '';
      state.phone = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(forgotPasswordApi.endpoints.startPasswordReset.matchFulfilled, (state, { payload: { transactionId, email, phone } }: PayloadAction<IForgotPasswordData>) => {
        state.transactionId = transactionId;
        state.email = email;
        state.phone = phone;
      })
      .addMatcher(forgotPasswordApi.endpoints.generateCode.matchFulfilled, (state, { payload }: PayloadAction<IForgotPasswordGenerateCodeResponse>) => {
        state.transactionId = payload.transactionId;
      });
  },
});

export default forgotPasswordSlice.reducer;

export const selectForgotPasswordData = (state: RootState) => state.forgotPassword;

export const { abortPasswordReset, setUsername } = forgotPasswordSlice.actions; 